export enum CalendlyUrl {
    INVOICE_REVIEW = 'https://calendly.com/amministrazione-dyname/invoice-review?primary_color=80a7a5',
    PV_ANALYSE = 'https://calendly.com/amministrazione-dyname/invoice-review-clone?primary_color=80a7a5',
    ESG_REPORTING = 'https://calendly.com/amministrazione-dyname/esg-and-sustainability-service-clone?primary_color=80a7a5',
    GREEN_MOBILITY = 'https://calendly.com/amministrazione-dyname/solar-analysis-clone?primary_color=80a7a5'
}